import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Logger from '../../functions/logging';
import FadeIn from '../../components/global/FadeIn';
import PageLoader from '../../components/global/PageLoader';

import * as helpers from '../../functions/helpers';
import * as TargetProcess from '../../functions/targetProcess';

import { setTargetParams } from '../../redux/actions/index';
import {
	PanelSegmentSelectCarousel,
	GroupPSSelectionWrapper,
	GroupPSSelection,
	PSSelectTitle, 
	PSSelectDetails,
	PSContinueTest,
	PSConfirmButton
} from './PanelSegmentSelectStyles';

import {
	PilotlyRegister,
	RegisterFormWrapper
} from '../../components/global/Styles/MainStyles';

/* Google analytics */
import SessionStatus from '../../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../../analytics/analytics-events/constants';

class PanelSegmentSelect extends Component {
	constructor(props) {
		super(props);

		this.state = {};

		this.handleContinue = this.handleContinue.bind(this);
		this.handelGoogleAnalytics = this.handelGoogleAnalytics.bind(this);
	}

	componentDidMount() {
		Logger.log(this.constructor.name, 'componentDidMount()');
		let { targetParams } = this.props;

		this.handelGoogleAnalytics(targetParams, 'pageload', SessionStatusEvent.PANEL_SEGMENT_SELECT, '', '', false, false, true);
	}

	handleContinue(group, psIndex) {
		let targetParams = { ...this.props.targetParams };
		Logger.log(this.constructor.name, "handleContinue()", targetParams);

		this.handelGoogleAnalytics(targetParams, 'psselected', SessionStatusEvent.PANEL_SEGMENT_SELECT, '', '', true, false, true);

		targetParams.ps = psIndex.toString();
		targetParams.psreq = '1';
		targetParams.psselected = '1';

		let panelSegment = group && group.panel_segment && group.panel_segment[psIndex]
			? group.panel_segment[psIndex]
			: null; 

		if (panelSegment && panelSegment.language_code) {
			targetParams.lang = panelSegment.language_code;
		}

		this.props.setTargetParams(targetParams);
		let newUrl = helpers.buildProcessTargetUrl(targetParams, true);
		window.location.href = newUrl;
	}

	/** Google analytics event */
	handelGoogleAnalytics(targetParams, gaType, userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent) {
		const { globalAnalyticsAdapter } = this.props;
		const isPartner = targetParams && targetParams.partner;

		let sessionStatus = new SessionStatus(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = isPartner ? targetParams.partner + ' PS Select' : 'Pilotly PS Select';
		sessionStatus.type = gaType;
		globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
	}

	renderPanelSegmentSelections(group) {
		if (group && group.panel_segment && group.panel_segment.length) {
			let psSelections = [];
			let psItemWidth = group.panel_segment.length >= 3 
				? Math.round((1 / group.panel_segment.length) * 100) 
				: (group.panel_segment.length === 2 ? 50 : 100 );
			let lastPSIndex = group.panel_segment.length - 1;

			group.panel_segment.forEach((panelSegment, psIndex) => {
				let width = psItemWidth + '%';
				let borderRight = psIndex === lastPSIndex ? 'none' : '2px #55acf2 solid';
				let psStyles = { width, borderRight };

				psSelections.push(
					<GroupPSSelectionWrapper key={panelSegment.id} {...psStyles}>
						<GroupPSSelection onClick={() => { this.handleContinue(group, psIndex); }}>
							<PSSelectTitle>{panelSegment.details_title}</PSSelectTitle>
							
							<PSSelectDetails>{panelSegment.details}</PSSelectDetails>

							<PSContinueTest>
								{panelSegment.continue_text}
							</PSContinueTest>
						</GroupPSSelection>
					</GroupPSSelectionWrapper>
				);
			});

			return (
				<FadeIn>
					{psSelections}
				</FadeIn>
			);
		}

		return <div></div>;
	}

	render() {
		let { fetchedGroup } = this.props;

		return (
			<PilotlyRegister>
				{!fetchedGroup ?
					<FadeIn>
						<RegisterFormWrapper className="register-form-wrapper text-center">
							<Link to='/home'>
								<PSConfirmButton className="waves-effect waves-light">
									<FormattedMessage id="invalid_confirm_url.button.home" defaultMessage={`Go Home`} />
								</PSConfirmButton>
							</Link>
						</RegisterFormWrapper>
					</FadeIn>
					:
					<FadeIn>
						<PanelSegmentSelectCarousel className="register-form-wrapper text-center">
							{this.renderPanelSegmentSelections(fetchedGroup)}
						</PanelSegmentSelectCarousel>
					</FadeIn>
				}
			</PilotlyRegister>
		);
	}
}

function mapStateToProps(state) {
	return {
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PanelSegmentSelect));



// WEBPACK FOOTER //
// ./src/pages/PanelSegmentSelect/PanelSegmentSelect.js